import { makeStyles } from "@material-ui/core/styles";
export const tripSelectionDialogCss = makeStyles(theme => ({
    paper1: {
        borderRadius: 6,
        minWidth: '878px !important'
    },
    closeButton: {
        fontSize: 18,
        color: '#e0e0e0',
    },
    dialogContentV1: {
       padding:24
    },
    dialogTitleV1: {
        padding:'16px 24px',
        "& .MuiTypography-root": {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }
    },
    vehicleNumber:{
        fontSize:14,
        fontWeight:600
    },
    own: {
      padding: "2px 10.5px",
      borderRadius: 3,
      margin: '0px 8px',
      fontSize: 11,
      color: "#fff",
      backgroundColor: '#0033cc',
      letterSpacing: '0.03em'
    },
    hired: {
      padding: "2px 10.5px",
      borderRadius: 3,
      margin: '0px 8px',
      fontSize: 11,
      color: "#fff",
      backgroundColor: '#e86825'
    },
    ownershipType: {
      marginLeft:8,
    },
    addTripButton: {
        boxShadow:'none',
        textTransform: 'capitalize', 
        fontWeight: 300,
        color:'#fff',
        padding: "6px 16px",
        backgroundColor: '#03c', 
        "&:hover": {
            backgroundColor: '#03c'
        }
    },
    firstCell:{
        borderBottom:'none',
        backgroundColor:'#fff'
    },
    lastCell:{
       visibility:'hidden',
       backgroundColor:'#fff'
    },
    middleCell:{
        visibility:'hidden',
        borderBottom:'none',
        backgroundColor:'#fff'
    }
}));
export const addExpenseDialogCss = makeStyles(theme => ({
    divV1: {
        fontWeight: 300,
        fontSize: 20
    },
    optionText: {
        color: '#888888',
        fontSize: 12,
        marginTop: 2
    },
    disableCta: {
        padding: '9px 26px 11px 28px',
        borderRadius: 4,
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1)',
        backgroundColor: '#efeff2',
        fontSize: 14,
        fontWeight: 'bold',
        color: '#3e3f42',
        height: 36,
        textTransform: 'capitalize',
        letterSpacing: '0.02em'
    },
    saveCta: {
        padding: '9px 26px 11px 28px',
        borderRadius: 4,
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1)',
        backgroundColor: '#09101e',
        fontSize: 14,
        fontWeight: 300,
        color: 'white',
        height: 36,
        textTransform: 'capitalize',
        letterSpacing: '0.02em',
        '&:hover': {
            backgroundColor: '#09101e',
        }
    },
    eventIcon: {
        color: 'grey'
    },
    closeButton: {
        fontSize: 18,
        color: '#e0e0e0',
    },
    paper1: {
        borderRadius: 6,
        minWidth: '878px !important'
    },
    paper2: {
        borderRadius: 6,
    },
    marginV1: {
        marginTop: 8
    },
    textFieldV1: {
        marginTop: 8,
        width: '48%'
    },
    title: {
        color: '#9ea0a5'
    },
    titleV1: {
        color: '#9ea0a5',
        marginTop: 24
    },
    dialogTitleV1: {
        paddingLeft: 22,
        paddingRight: 22,
        paddingTop: 12,
        paddingBottom: 12,
        "& .MuiTypography-root": {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }
    },
    listBoxAutoCompelete: {
        margin: 0,
        padding: 0
    },
    listBoxOption: {
        padding: 0,
        minHeight: 46,
        maxHeight: 46,
        borderBottom: '1px solid #eaedf3',
        "&:first-child": {
        },
        "&:last-child": {
        }
    },
    switchControl: {
        marginLeft: 16
    },
    switch: {
        '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
            backgroundColor: '#0033cc'
        },
        '& .MuiSwitch-colorSecondary.Mui-checked': {
            color: '#0033cc'
        }
    },
    da1: {
        paddingTop: 21,
        paddingBottom: 21,
        paddingRight: 24
    },
    cancelButton: {
        textTransform: 'capitalize', marginRight: '16px', fontWeight: 300, backgroundColor: '#f6f7f9', paddingLeft: '20px', paddingRight: 20, paddingTop: 9, paddingBottom: 11,
        letterSpacing: '1px',
        "&:hover": {
            backgroundColor: '#f6f7f9'
        }
    },
    confirmV1: {
        backgroundColor: 'black',
        color: 'white',
        textTransform: 'capitalize',
        fontWeight: 300,
        letterSpacing: '1px',
        paddingLeft: 36,
        paddingRight: 36,
        paddingTop: 9,
        paddingBottom: 11,
        "&:hover": {
            backgroundColor: 'black'
        }
    },
    divV2: {
        display: 'flex', justifyContent: 'space-betwaddExpenseDialogCsseen', marginTop: 16
    },
    wV1: {
        width: '50%'
    },
    divV3: {
        width: '50%', marginLeft: 30
    },
    divV4: {
        display: 'flex', marginTop: 20
    },
    divV5: {
        fontWeight: 300, fontSize: 16
    },
    marginV2: {
        marginTop: 16
    },
    marginV3: {
        marginTop: 28
    },
    radioV1: {
        color: "#0033cc !important"
    },
    radioV1Error: {
        color: 'red !important'
    },
    paymentTypeLabel: {
        marginBottom: 0
    },
    paymentTypeLabelError: {
        marginBottom: 0,
        color: 'red'
    },
    inputAdornmentV1: {
        height: '0 !important',
        alignItems: 'baseline'
    },
    textNote: {
        alignItems: 'start !important',
        "& .MuiInputBase-root": {
            alignItems: 'start !important'
        }
    },
    newExpenseTypeV1: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        color:'#5170f0',
        backgroundColor: '#e3e8fd',
        padding:'12px 24px'
    },
    capitalize: {
        textTransform: 'capitalize',
        fontWeight:600,
        color:"#0b1323"
    },
    newExpenseTypeV2: {
        display: 'flex',
        alignItems: 'center',
    },
    selectV1: {
        "& .MuiSelect-selectMenu": {
            paddingTop: 4,
            paddingBottom: 4,
            fontSize: 14
        }
    },
    customTextField: {
        marginTop: 8,
        "& .MuiFormHelperText-contained": {
            fontSize: 14,
            marginLeft: '0px !important'
        }
    },
    textTransformCaptialize: {
        textTransform: 'capitalize'
    },
    fontSize32: {
        fontSize: 32,
    },
    fontSize18: {
        fontSize: 18,
    },
    cherveRightIcon:{
        color:'#5170f0'
    },
    divV6: {
        marginLeft: 16, fontWeight: 300
    },
    divExpenseName: {
        display: 'flex', width: '100%', paddingTop: 5, paddingBottom: 5, paddingLeft: 16, fontWeight: 300
    },
    divMargin: {
        margin: 0, marginTop: 6
    },
    divV7: {
        display: 'flex', alignItems: 'end', marginTop: 16
    },
    divV8: {
        display: 'flex', alignItems: 'center'
    },
    divV9: {
        marginLeft: 4, marginRight: 4
    },
    paperWidth: {
        maxWidth: '460px !important'
    },
    divTripV2: {
        fontSize: 16,
        fontWeight: 300,
        marginTop: 6
    },
    mtV2: {
        marginTop: 16
    },
    shopOption: {
        paddingLeft: 0,
        paddingRight: 0,
        borderBottom: '1px solid #eaedf3',
        paddingTop: 0,
        paddingBottom: 0
    },
    shopListItem: {
        padding: '12px 15px',
        minHeight: 46,
        margin: 0,
        // maxHeight: 46,
        width: '100%',
        //borderBottom:"1px solid #eaedf3"
    },
    shopListItem1: {
        padding: '12px 15px',
        minHeight: 46,
        margin: 0,
        maxHeight: 46,
        width: '100%',
        color: "#5170f0",
        backgroundColor: '#E3E8FD'
    },
    billingTypeRadio: {
        maxWidth: '100% !important',
        marginTop: 16,
        '& .MuiFormControl-fullWidth': {
            //maxWidth:'100% !important'
        },
        '& .MuiFormControlLabel-root': {
            //marginRight:0
        },
        '& .MuiRadio-root': {
            //display:'none'
        },
        '& .MuiFormLabel-root': {
            fontSize: 12,
            letterSpacing: '0.05em',
            marginBottom: 12,
        }
    },
    billingTypeLabel: {
        //height: 36,
        //padding: '6px 12px',
        borderRadius: 16,
        marginRight: 6,
        marginLeft: 0,
        backgroundColor: '#e4e4e4',
        '& .MuiButtonBase-root': {
            display: 'none'
        },
        '& .MuiTypography-root': {
            fontSize: 14,
            padding: '8px 12px',
            borderRadius: 16,
            backgroundColor: '#e4e4e4',
            color: '#6b778c',
            fontWeight: 300,
        },
        '& span.Mui-checked+span': {
            color: '#0033cc',
            fontWeight: 300,
            backgroundColor: '#d1ddff',
            border: '1px solid #0033cc',
            paddingTop: 7,
            paddingBottom: 7,
            paddingLeft: 11,
            paddingRight: 11,
            fontSize: 14,
        }
    },
    titleBullet: {
        borderRadius: "50%",
        backgroundColor: "lightgrey",
        fontSize: 8,
        color: "lightgrey",
        margin: "0px 6px",
        marginTop: -2
    },
    addPersonIcon: {
        color: '#0033cc',
        marginRight: 10
    },
    listBoxV1: {
        paddingTop: '0px !important',
        paddingBottom: '0px !important'
    },
    autoCompletePaper: {
        marginBottom: '14px !important'
    },
    cherveRightIconV1: {
        marginLeft: 10,
        float: 'right',
        color: '#5170f0'
    },
    vehicleListItemFlex:{
        display:'flex',
        alignItems:'center',
        flexDirection:'row'
    },
    vehicleListItem: {
        padding: '12px 15px',
        minHeight: 46,
        margin: 0,
        maxHeight: 46,
        width: '100%',
        display: 'flex',
        alignItems:'center',
        justifyContent:'space-between'
    },
    divVehicleListing: {
      overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'
    },
    vehicleNumberSuffix: {
      marginLeft: 3,
      color: "#0033cc",
      marginRight: 3,
      fontWeight: 300
    },
    truckIcon: {
      fontSize: 30, marginTop: -3
    },
    own: {
      padding: "2px 10.5px",
      borderRadius: 3,
      margin: '0px 8px',
      fontSize: 11,
      color: "#fff",
      backgroundColor: '#0033cc',
      letterSpacing: '0.03em'
    },
    hired: {
      padding: "2px 10.5px",
      borderRadius: 3,
      margin: '0px 8px',
      fontSize: 11,
      color: "#fff",
      backgroundColor: '#e86825'
    },
    vehicleStatus: {
      fontSize: 12,
      width:'100%',
      textTransform: 'capitalize',
      alignItems:'center',
      display:'flex',
      justifyContent:'space-between'
    },
    ownershipType: {
      marginLeft: 'auto',
      width: 70,
      textAlign: 'right',
      fontWeight: 'bold'
    },
    partyAddListItem: {
      padding: '12px 15px',
      margin: 0,
      backgroundColor: '#e3e8fd',
      color: '#0033cc',
      // fontWeight: 300,
      minHeight: 46,
      width: '100%',
      maxHeight: 46
    },
    avilableBullet: {
      borderRadius: "50%",
      backgroundColor: "#2d9d78",
      fontSize: 8,
      color: "#2d9d78",
      margin: "0px 6px",
      //marginTop: -2
    },
    onTripBullet: {
      borderRadius: "50%",
      backgroundColor: "#0033cc",
      fontSize: 8,
      color: "#0033cc",
      margin: "0px 6px",
      //marginTop: -2
    },
    addTripButton: {
        textTransform: 'capitalize', 
        fontWeight: 300,
        color:'#fff',
        padding: "10px 24px",
        backgroundColor: '#03c', 
        letterSpacing: '1px',
        "&:hover": {
            backgroundColor: '#03c'
        }
    },
    changeTripButton:{
        textTransform: 'capitalize', 
        fontWeight: 300,
        color:'#03c',
        padding: "8px 16px",
        backgroundColor: '#fff', 
        letterSpacing: '1px',
        "&:hover": {
            backgroundColor: '#fff'
        }
    },
    changeDriverButton:{
        textTransform: 'capitalize', 
        fontWeight: 300,
        color:'#03c',
        padding: "8px 16px",
        backgroundColor: '#fff', 
        letterSpacing: '1px',
        "&:hover": {
            backgroundColor: '#fff'
        }
    },
    journeyBox:{
        padding: '10px 16px 16px',
        borderRadius:8,
        backgroundColor:'#f6f6f8',
        marginTop:16
    },
    customerName:{
        fontSize:14
    },
    vehicleNumber:{
        fontSize:14,
        fontWeight:600,
        color:'#0b1323'
    },
    loadCountBox:{
        backgroundColor:'#fff',
        borderRadius:12,
        padding:'9px 12px'
    },
    switchControl1: {
      marginTop: 8,
      marginBottom: 8
    },
    switchLabel: {
      marginLeft: 0,
      marginBottom:0,
    },
    expenseTypeListItem: {
      padding: '12px 15px',
      minHeight: 46,
      margin: 0,
      maxHeight: 46,
      width: '100%'
    }
}));
